import { useEffect, useState } from "react";
import { TRIAL_TEST_MINUTES } from "../config/subscriptionPlans";

/**
 * Re-render every few seconds while on a trial so countdown and payment gate stay in sync with trialEndsAt.
 */
export function useSubscriptionClock(user) {
    const [tick, setTick] = useState(0);
    const onTrial =
        user?.subscriptionStatus === "trialing" && Boolean(user?.trialEndsAt || user?.subscriptionMinutesRemaining != null);

    useEffect(() => {
        if (!onTrial) return undefined;
        const ms = TRIAL_TEST_MINUTES > 0 ? 15_000 : 60_000;
        const id = setInterval(() => setTick((n) => n + 1), ms);
        return () => clearInterval(id);
    }, [onTrial, user?.trialEndsAt]);

    return tick;
}
